import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  height: 80px;
  margin-top: auto;
`;
